import { X } from 'lucide-react'

/**
 * The visible close control for a modal surface.
 *
 * Neither `components/ui/dialog` nor `components/ui/sheet` renders one: both
 * close only on Escape or a backdrop click. On a phone there is no Escape key,
 * and the backdrop can be a sliver of screen, so a dialog without this reads as
 * a trap. That is why this is not gated on viewport — desktop has no visible
 * close control either.
 *
 * Unlike `MobileBackButton`, this one really does dismiss, so it keeps the X.
 */
const PopupCloseButton = ({
	onClose,
	ariaLabel = 'Close',
	className = '',
}: {
	onClose: () => void
	ariaLabel?: string
	className?: string
}) => (
	<button
		type="button"
		onClick={onClose}
		aria-label={ariaLabel}
		/*
			The BUTTON stays 44px square: the minimum touch target in the MDT
			mobile guidance. Only the blue disc inside it is small, matching
			MobileBackButton, so the two controls read as a pair rather than one
			being half again the size of the other.
		*/
		className={`group inline-flex items-center justify-center w-11 h-11 flex-shrink-0 bg-transparent p-0 focus:outline-none ${className}`}
	>
		<span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-sm transition-transform duration-150 group-hover:scale-105 group-active:scale-[0.92] group-focus-visible:ring-2 group-focus-visible:ring-ring">
			<X className="w-4 h-4" />
		</span>
	</button>
)

export default PopupCloseButton
